export default __webpack_public_path__ + "11ac4b60117b7f8f6b659cdac62d0091.png";